import React from 'react'
import SelectInput from '../../form/select'

class Step2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      countries: this.props.data.countries || this.props.countries
    };
  }


  onCountrySelect = (country) => {
    this.setState({ countries: country.value });
  };

  submit = (e) => {
    e.preventDefault();
    this.props.submit(this.state);
  };

  render() {
    const { countries } = this.state;
    const { countriesList } = this.props;
    return (
      <React.Fragment>
        <p className="title mb-10">Where do your customer reside?</p>

        <p className="mb-30 text-tuna">Lussy will crawl your website to find relevant information like social profiles.</p>
        <form onSubmit={this.submit}>
          <div className="mx-auto" style={{ maxWidth: '370px' }}>
            <div className="mb-20">
              <SelectInput
                className="react-select"
                name="countries"
                onChange={this.onCountrySelect}
                options={countriesList.map(country => { return { label: country, value: country } })}
                placeholder="Country"
                required
                value={countries}
              />
            </div>

            <input
              className="btn btn--primary col-12 mb-10"
              type='submit'
              value='Next'
            />
          </div>
        </form>

      </React.Fragment>
    );
  }
}

export default Step2
